import React from 'react';
import { IconButton } from '@mui/material';
import { Fullscreen, FullscreenExit } from '@mui/icons-material'

const MapFullscreenIcon = (props) => {
    // 全画面表示切り替え
    function switchingFullScreen(e) {
        props.fullscreenHandle.active ?
            props.fullscreenHandle.exit() :
            props.fullscreenHandle.enter();
    }

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    return (
        <IconButton
            sx={{
                position: 'absolute',
                width: '29px',
                height: '29px',
                top: props.top,
                right: '10px',
                zIndex: 500,
                border: '1px solid rgba(0, 0, 0, 0.3)',
                borderRadius: '5px',
                backgroundColor: 'white',
                '&:hover': {
                    backgroundColor: 'rgb(243, 243, 243)'
                }
            }}
            onClick={switchingFullScreen}
        >
            {props.fullscreenHandle.active
                ? <FullscreenExit sx={iconStyle} />
                : <Fullscreen sx={iconStyle} />
            }
        </IconButton>
    );
};

export default MapFullscreenIcon;